const locale = {
	PROJECTS_PLANNED_VALUE: 'Planned value: {value}',
	PROJECTS_PLANNED_EXPENSES: 'Planned expenses: {value}',

	DETAILS_PROJECTS_TAB_ACTIVITIES_KANBAN: 'Activities Kanban',

	// #region Projects fields
	DETAILS_PROJECTS_FIELD_TITLE: 'Title',
	DETAILS_PROJECTS_FIELD_STATUS: 'Project Status',
	DETAILS_PROJECTS_FIELD_TYPE: 'Project Type',
	DETAILS_PROJECTS_FIELD_COMPANY: 'Company',
	DETAILS_PROJECTS_FIELD_PERSON: 'External Reference',
	DETAILS_PROJECTS_FIELD_ASSIGNED_USER: 'Assigned User',
	DETAILS_PROJECTS_FIELD_ASSIGNED_USER_2: 'Assigned User 2',
	DETAILS_PROJECTS_FIELD_ASSIGNED_GROUP: 'Assigned Group',
	DETAILS_PROJECTS_FIELD_DATE_FROM: 'Start date',
	DETAILS_PROJECTS_FIELD_DATE_TO: 'End date',
	DETAILS_PROJECTS_FIELD_PROGRESS: 'Progress',
	DETAILS_PROJECTS_FIELD_INTERNALNUMBER: 'Internal number',
	DETAILS_PROJECTS_FIELD_VALUE_PLANNED: 'Planned value',
	DETAILS_PROJECTS_FIELD_EXPENSES_PLANNED: 'Planned expenses',
	DETAILS_PROJECTS_FIELD_EXPENSES_OTHER: 'Other expenses',
	DETAILS_PROJECTS_FIELD_LENGTH_HOURS_PLANNED: 'Planned hours',
	DETAILS_PROJECTS_FIELD_LENGTH_HOURS: 'Used hours',
	DETAILS_PROJECTS_FIELD_TAGS: 'Tags',
	DETAILS_PROJECTS_FIELD_WARNING: 'Warning',
	DETAILS_PROJECTS_FIELD_BLOCKED: 'Blocked',
	// #endregion

	// #region Projects general stats section
	PROJ_SECTION_BILLING_STATS_TITLE: 'Project stats',

	PROJ_SECTION_BILLING_STATS_VALUE_PLANNED: 'Planned value',
	PROJ_SECTION_BILLING_STATS_VALUE_FINAL: 'Current value',
	PROJ_SECTION_BILLING_STATS_VALUE_MISSING: 'Missing value',

	PROJ_SECTION_BILLING_STATS_EXPENSES_TOTAL: 'Current expenses',
	PROJ_SECTION_BILLING_STATS_EXPENSES_INVOICES: 'by Invoices',
	PROJ_SECTION_BILLING_STATS_EXPENSES_WORKREPORTS: 'by Workreports',
	PROJ_SECTION_BILLING_STATS_EXPENSES_OTHER: 'by other',

	PROJ_SECTION_BILLING_STATS_PROFIT_PLANNED: 'Planned profit',
	PROJ_SECTION_BILLING_STATS_PROFIT_FINAL: 'Current profit',
	// #endregion

	// #region Projects WorkReports stats section
	PROJ_SECTION_WORKREPORTS_STATS_TITLE: 'Users stats',

	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_TYPE: 'Type',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_HOURS_PLANNED: 'Planned hours',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_HOURS: 'Current hours',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_VALUE_PLANNED: 'Planned value',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_EXPENSES_PLANNED: 'Planned expenses',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_EXPENSES_BILLED: 'Billed expenses',
	PROJ_SECTION_WORKREPORTS_STATS_COLUMN_PROFIT_PLANNED: 'Planned profit',

	PROJ_SECTION_WORKREPORTS_STATS_NO_TYPE: 'No type',
	PROJ_SECTION_WORKREPORTS_STATS_TOTAL: 'Total'
	// #endregion
};

export default locale;
